export default __webpack_public_path__ + "static/media/Prison-3D-Model-03.30281834.jpg";